<template>
  <v-container
    class="d-flex flex-column"
    fluid
  >
    <v-row  class="justify-center text-h5 text-md-h4 text-lg-h4 text-xl-h3 text-center font-weight-bold pa-7 ma-xl-12" >
        Tableau Dashboard & Tutorial Portal
    </v-row>
    <v-row  class="d-flex justify-space-around ma-xl-16">
      <v-col sm="6" md="3" lg="3" xl="3" v-for="image in images" :key="image.name">
          <a v-if="image.out" :href="image.url" target="_blank">
            <v-img
              :src="image.path"
              :height=height
              contain
            ></v-img>
          </a>
          <router-link v-else :to="image.url">
              <v-img
                :src="image.path"
                :height=height
                contain
              ></v-img>
          </router-link>
      </v-col>
    </v-row>
    <v-footer height="50px" padless app>
      <v-col
        class="text-center text-h6 "
      >
        For further question, contact <a v-bind:href="'mailto:' + email" class="text-decoration-underline" style="color:black; ">{{ email }}</a>
      </v-col>
    </v-footer>
  </v-container>
</template>

<script>
export default {
  name: "Tableauhome",
  data(){
    return{
      images:[
        {path: require('../assets/image with frame and text/sub-report-directory.png'),
          name:"Report Mindmap", url:'/mindmap', out:false},
          {path: require('../assets/image with frame and text/Tableau report search.png'),
          name:"Tableau Report Search", url:'https://script.google.com/a/afterpay.com/macros/s/AKfycbxxe9DD6yXRQbg1IOc0IWVyBW-cb-ZNStpdH-pGZZGX8ahJ_04/exec', out:true},
      // {path: require('../assets/image with frame and text/sub-tableau tutorial.png'),
      //     name:"Tableau tutorial", out:true, url:'https://sites.google.com/afterpay.com/tableau-search-bi/general-training'},
      {path: require('../assets/image with frame and text/sub-tableau tutorial.png'),
          name:"Tableau tutorial", out:false, url:'/tutorial'}],
      email:this.$email
    }
  },
  computed:{
    height(){
      switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 350
          case 'sm': return 350
          case 'md': return 350
          case 'lg': return 450
          case 'xl': return 650
          default: return 550
        }
    }
  }

}

</script>

<style scoped>


</style>
